// extracted by mini-css-extract-plugin
export var active = "_bo-7";
export var container = "_bo-0";
export var evenWidth = "_bo-4";
export var large = "_bo-5";
export var outlet = "_bo-8";
export var slide = "_bo-2";
export var small = "_bo-6";
export var tab = "_bo-3";
export var tabs = "_bo-1";